import * as React from "react";
const FieldGroup = ({ onSelect, selected, group, text, title }) => /* @__PURE__ */ React.createElement(
  "a",
  {
    onClick: () => onSelect(group),
    role: "button",
    style: { fontWeight: selected ? "bold" : "normal" },
    tabIndex: 0,
    title
  },
  text
);
export default FieldGroup;
